// Shared grade level options used across the application
// This ensures consistency between curriculum matcher, quiz creation, and other components

export const GRADE_LEVELS = [
  { value: 'K', label: 'Reception/Kindergarten' },
  { value: '1', label: 'Primary/Year 1' },
  { value: '2', label: 'Primary/Year 2' },
  { value: '3', label: 'Primary/Year 3' },
  { value: '4', label: 'Primary/Year 4' },
  { value: '5', label: 'Primary/Year 5' },
  { value: '6', label: 'Primary/Year 6' },
  { value: '7', label: 'Year/Grade 7' },
  { value: '8', label: 'Year/Grade 8' },
  { value: '9', label: 'Year/Grade 9' },
  { value: '10', label: 'Year/Grade 10' },
  { value: '11', label: 'Year/Grade 11' },
  { value: '12', label: 'Year/Grade 12' }
];

// Helper function to map individual grade to range format (for backend compatibility)
export const mapGradeToRange = (grade) => {
  if (!grade) return null;
  
  const gradeNum = parseInt(grade, 10);
  
  if (grade === 'K' || gradeNum <= 2) {
    return 'K-2';
  } else if (gradeNum >= 3 && gradeNum <= 5) {
    return '3-5';
  } else if (gradeNum >= 6 && gradeNum <= 8) {
    return '6-8';
  } else if (gradeNum >= 9 && gradeNum <= 12) {
    return '9-12';
  }
  
  return null;
};

// Helper function to map range format to individual grade (for display)
export const mapRangeToGrade = (range) => {
  if (!range) return null;
  
  // If it's already an individual grade, return it
  if (['K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'].includes(range)) {
    return range;
  }
  
  // Map ranges to a representative grade
  switch (range) {
    case 'K-2':
      return 'K';
    case '3-5':
      return '3';
    case '6-8':
      return '6';
    case '9-12':
      return '9';
    default:
      return null;
  }
};
